import { twMerge } from 'tailwind-merge';

interface LayoutProps {
  children?: React.ReactNode;
  className?: string;
}
export const Layout = (props: LayoutProps) => {
  const { children, className } = props;
  return (
    <main className={twMerge(['flex-1 overflow-y-auto focus:outline-hidden relative max-w-full mx-auto', className])}>
      <div>{children}</div>
    </main>
  );
};
